import CityLandingPage from './page';

const portoAlegreData = {
  cityName: 'Porto Alegre',
  state: 'RS',
  slug: 'palestra-silenciosa-porto-alegre',
  coordinates: {
    lat: -30.0346,
    lng: -51.2177,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa porto alegre',
    'silent conference porto alegre',
    'eventos corporativos porto alegre',
    'aluguel fones sem fio porto alegre',
    'palestra silenciosa rs',
    'conferência poa fones sem fio',
  ],
  heroTitle: 'palestra silenciosa porto alegre',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências e workshops em Porto Alegre. Equipe e equipamentos enviados de São Paulo, com a mesma qualidade em qualquer lugar do Brasil.',
  localStats: {
    clients: '50+',
    satisfaction: '98%',
  },
  localTestimonials: [],
  localFAQs: [
    {
      question: 'Vocês atendem os principais centros de eventos de Porto Alegre?',
      answer: 'Sim! Atendemos todos os principais espaços de Porto Alegre: Centro de Eventos da FIERGS, Bourbon Convention Shopping, hotéis corporativos em Moinhos de Vento e Bela Vista, e o Cais Mauá. Nossa equipe conhece a cidade e garante logística ágil.',
    },
    {
      question: 'A palestra silenciosa funciona para eventos bilíngues em Porto Alegre?',
      answer: 'Absolutamente! Porto Alegre é uma cidade com forte presença de empresas internacionais e nosso sistema é perfeito para eventos bilíngues e multilíngues. Com até 10 canais simultâneos, português, inglês e espanhol podem ser transmitidos ao mesmo tempo.',
    },
    {
      question: 'Qual o prazo para reservar equipamentos em Porto Alegre?',
      answer: 'Recomendamos reservar com 10 a 15 dias de antecedência para Porto Alegre. Em períodos de alta demanda (Expointer, FENAC, semanas de eventos corporativos), sugerimos 3 a 4 semanas. Atendemos urgências conforme disponibilidade.',
    },
    {
      question: 'Os equipamentos funcionam em eventos na orla do Guaíba?',
      answer: 'Sim! Nossos transmissores sem fio funcionam muito bem em ambientes externos como a Orla do Guaíba, Parcão e espaços ao ar livre em Porto Alegre. O alcance de 100 metros em campo aberto garante cobertura total mesmo nos eventos mais espalhados.',
    },
    {
      question: 'Vocês atendem cidades da região metropolitana de Porto Alegre?',
      answer: 'Sim! Além de Porto Alegre, atendemos toda a Região Metropolitana: Canoas, São Leopoldo, Novo Hamburgo, Gravataí e outras cidades do RS. Nossa equipe tem logística estruturada para toda a Grande Porto Alegre.',
    },
  ],
  seoTitle: 'Palestra Silenciosa Porto Alegre | Fones Sem Fio POA | STIB',
  seoDescription: 'Palestra silenciosa Porto Alegre: fones sem fio para eventos corporativos e conferências em POA. Atendemos FIERGS, Bourbon Convention e toda Grande POA. Orçamento rápido!',
};

export default function PortoAlegreLandingPage() {
  return <CityLandingPage cityData={portoAlegreData} />;
}
